import { Component, Input } from '@angular/core';

@Component({
  selector: 'historical-svg',
  templateUrl: './historical-svg.component.html',
  styleUrls: ['./../../svg.scss']
})
export class HistoricalSvgComponent {
  @Input() active:boolean=false;
  constructor() { }
}
